import { render, staticRenderFns } from "./MaterialDashboardCard.vue?vue&type=template&id=21d7d4b1&"
import script from "./MaterialDashboardCard.vue?vue&type=script&lang=js&"
export * from "./MaterialDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDashboardCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports